import { Button, Center, Group, Pagination, Stack } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useDeleteUser, useQueryUsers } from "hooks/users";
import { UsersList, UsersSearchFilter } from "components/users";
const perPage = 10;

export const Users = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1", 10);
  const [name, setName] = useState("");

  const deleteUserMutation = useDeleteUser(() => {});

  const { isLoading, isError, error, users, count } = useQueryUsers({
    name,
    page,
    perPage,
  });

  if (isError) {
    return (
      <div>
        Something went wrong:
        {error?.message}
      </div>
    );
  }
  if (isLoading) {
    return null;
  }

  const changePage = (page: number) => {
    setSearchParams({ page: page.toString() });
  };

  const goToUser = (uid: string) => {
    navigate(`${window.location.pathname}/${uid}`);
  };

  const goToCreateUser = () => {
    navigate(`${window.location.pathname}/create`);
  };

  const deleteUser = (uid: string) => {
    deleteUserMutation.mutate({ uid });
  };

  return (
    <Stack>
      <Group justify="space-between">
        <UsersSearchFilter onUpdateName={setName} />
        <Button onClick={goToCreateUser}>Create</Button>
      </Group>
      <UsersList
        users={users || []}
        onUserChosen={goToUser}
        onUserDelete={deleteUser}
      />
      <Center mt="xl">
        <Pagination
          mr="xl"
          value={page}
          total={Math.ceil(count! / perPage)}
          onChange={changePage}
        />
      </Center>
    </Stack>
  );
};
